import type { FC } from "react";

import { UpgradeLink } from "app/components/React/Table/cells";

import { AppTooltip } from "../../../tooltips/src/AppTooltip/AppTooltip";

import { AppContent, AppIcon, AppRow, HoverIcon, Icon } from "./StyledComponents";

const CoreAppCell: FC<ICoreAppCellProps> = ({
    value,
    row,
    appInfo,
    store,
    getInternalLink,
    onTrackInternalLink,
    getExternalLink,
    onTrackExternalLink,
    getAssetsUrl,
    showStoreIcon,
    bold,
    hideMonthlyDownloads = false,
}) => {
    enum Type {
        App = "app",
    }

    const storeIcon = store === "Google" || store === "0" ? "google-play" : "i-tunes";
    return (
        <AppRow bold={bold}>
            {appInfo?.title === "grid.upgrade" ? (
                <UpgradeLink />
            ) : (
                <>
                    <AppIcon
                        iconType={Type.App}
                        iconName={appInfo?.title}
                        iconSrc={appInfo?.icon}
                    />
                    <AppContent
                        hasStore={showStoreIcon}
                        hasLeader={row.isLeader}
                        hasExternalLink={!!getExternalLink}
                    >
                        <AppTooltip
                            app={appInfo}
                            appId={row.mainItem || row.appId}
                            store={row.tooltip?.appStore}
                            placement="top"
                            getAssetsUrl={getAssetsUrl}
                            hideMonthlyDownloads={hideMonthlyDownloads}
                        >
                            {getInternalLink ? (
                                <a
                                    className="CoreAppCell-app-text CoreAppCell-link"
                                    href={getInternalLink(row)}
                                    onClick={() => onTrackInternalLink?.(row)}
                                >
                                    {value}
                                </a>
                            ) : (
                                <span className="CoreAppCell-app-text">{value}</span>
                            )}
                        </AppTooltip>
                        {showStoreIcon ? <Icon iconName={storeIcon} /> : null}
                        {row.isLeader ? (
                            <Icon
                                iconName="winner"
                                bold={true}
                            />
                        ) : null}
                        {getExternalLink ? (
                            <a
                                href={getExternalLink(row)}
                                onClick={() => onTrackExternalLink?.(row)}
                                target="_blank"
                            >
                                <HoverIcon iconName="link-out" />
                            </a>
                        ) : null}
                    </AppContent>
                </>
            )}
        </AppRow>
    );
};
CoreAppCell.displayName = "CoreAppCell";

interface IAppInfo {
    appStore?: string;
    title?: string;
    author?: string;
    icon?: string;
    price?: string;
    category?: string;
}

interface ICoreAppCellProps {
    value: string;
    row: any;
    appInfo: IAppInfo;
    store: string;
    getInternalLink?: (row: FixmeType) => string;
    onTrackInternalLink?: (a?: FixmeType, b?: FixmeType, c?: FixmeType, d?: FixmeType) => void;
    getExternalLink?: (row: FixmeType) => string;
    onTrackExternalLink?: (a?: FixmeType, b?: FixmeType, c?: FixmeType, d?: FixmeType) => void;
    getAssetsUrl: (suffix: string) => string;
    showStoreIcon?: boolean;
    bold?: boolean;
    hideMonthlyDownloads?: boolean;
}

export default CoreAppCell;
